import React from 'react';
import { AsComponentProp, filterChildrenByType } from '@tanium/coreui-utils';
import styled from '@tanium/react-emotion';
import { PAGE_HEADER_COREUITYPE, PageBase } from '@tanium/react-page-base';
import { Stack, StackChild } from '@tanium/react-stack';

export interface Props<T> {
  /**
   * The page's content.
   */
  children: React.ReactNode;

  /**
   * Header that appears at top of page
   */
  header: React.ReactNode;
  /**
   * A component to wrap the  children of the PageBase. This is useful if, for example, you wish to
   * set up a grid or flexbox layout for your page.
   */
  contentContainer?: AsComponentProp<T>['as'];
}

const PageContent = styled('div')({});

function getHeader(header: React.ReactNode) {
  return filterChildrenByType(header, PAGE_HEADER_COREUITYPE, 'Page');
}

export function Page<T>({ children, header, contentContainer: Container = PageContent }: Props<T>) {
  return (
    <PageBase>
      <Stack direction="column" height="100%">
        {getHeader(header)}
        <StackChild component={Container} grow={1}>
          {children}
        </StackChild>
      </Stack>
    </PageBase>
  );
}
